<template>
  <account-security-settings />
</template>

<script>
import AccountSecuritySettings from "@/components/Ondemand/Settings/AccountSecurity/AccountSecurity.vue";
export default {
  components: {
    AccountSecuritySettings,
  },
};
</script>

<style></style>
